import { Component, ElementRef, HostListener, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import FieldsSettings from 'src/app/forms/fields/fields.settings';
import { MapState } from 'src/app/interfaces/map.interface';
import { MapFilters, NestedBucketIndividualRole } from '../map.enum';

@Component({
  selector: 'app-selected-filters-block',
  templateUrl: './selected-filters-block.component.html',
  styleUrls: ['./selected-filters-block.component.scss'],
})
export class SelectedFiltersBlockComponent implements OnChanges {
  @Input({ required: true }) public mapState: MapState;

  public isCollapsed = true;
  public isTextTruncated = false;
  public filters: string[][] = [];

  @ViewChild('textBlock', { static: false })
  private textBlock: ElementRef<HTMLElement>;

  @HostListener('mouseover')
  public onOver(): void {
    this.checkIsTextBlockTruncated(this.textBlock.nativeElement);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['mapState']) {
      this.updateDisplayedFilters();
    }
  }

  /**
   * @description Manages the custom accordion container content by switching isCollapsed
   *              flag value.
   */
  public toggleFiltersVisibility(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  private checkIsTextBlockTruncated({ clientWidth, scrollWidth }: HTMLElement): void {
    this.isTextTruncated = clientWidth < scrollWidth;
  }

  /**
   * @description Converts the current map state props to array of array.
   *              Removes roles filter for any tab except People one.
   */
  private updateDisplayedFilters(): void {
    if (this.mapState.filter !== MapFilters.PEOPLE) {
      delete this.mapState.roles;
    }

    if (this.mapState.roles && this.mapState.roles.includes(NestedBucketIndividualRole.PATIENT)) {
      delete this.mapState.specialties;
    }
    if (this.mapState.roles && this.mapState.roles.includes(NestedBucketIndividualRole.MED_STAFF)) {
      delete this.mapState.diseases;
    }

    this.filters = Object.entries(this.mapState)
      .map(([key, value]: [string, string | string[]]) => this.getFilterKeyMapper(key, value))
      .filter(Boolean);
  }

  private getFilterKeyMapper(filter: string, value?: string | string[]): string[] {
    if (value instanceof Array) {
      switch (filter) {
        case 'roles':
          return value && value.length
            ? value.map((item: string) => `${FieldsSettings.INDIVIDUAL_ROLE_PREFIX}${item}`)
            : null;
        case 'diseaseTitles':
        case 'specialtyTitles':
        case 'charityFocusesTitle':
          return value && value.length > 0 ? value : null;
        default:
          return null;
      }
    } else if (filter === 'keyword') {
      return value ? [String(value)] : null;
    }
    return null;
  }
}
